export default __webpack_public_path__ + "static/media/bullets.30cd23b2.svg";